import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { TwoColumnPropertiesType } from '@appTypes/CategoryAppType';
import { SectionBlocks } from '@components/SectionBlocks';
import useSelector from '@redux/typedHooks';
import { PaywallBox } from '@components/paywall/PaywallBox';
import { LoaderContent } from '../../LoaderPage';

type Props = {
  tab: TwoColumnPropertiesType['tabs'][number] | undefined;
  slug: string;
};

export const TabBody = ({ tab, slug }: Props) => {
  const { isLoading: isAuthLoading, isAuthenticated } = useAuth0();
  const categoryAppMeta = useSelector((state) => state.sitestructure.categoryApps[`${slug}/twoColumnApp`]?.meta);

  const paywall = tab?.paywallReference;
  const isLocked = paywall?.isAccessibleForUser === false && !!paywall.paywallOptions;
  const isWaitingForAuthFetch =
    isAuthLoading || categoryAppMeta?.isUpdating || (isAuthenticated && !categoryAppMeta?.isLoggedIn);

  if (isLocked && isWaitingForAuthFetch) return <LoaderContent />;
  if (isLocked && paywall?.paywallOptions) {
    return (
      <PaywallBox
        paywallOptions={paywall.paywallOptions}
        paywallLink={paywall.paywallLink}
        paywallLinkSecondary={paywall.paywallLinkSecondary}
      />
    );
  }
  return <SectionBlocks content={tab?.content || []} />;
};
